/**
 * @generated SignedSource<<01728dde849af311af226e1e1ac7a435>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaceholderPlannerMenu_placeholder$data = {
  readonly first_name: string;
  readonly id: number;
  readonly last_name: string;
  readonly project_memberships: ReadonlyArray<{
    readonly id: number;
    readonly workstream: {
      readonly id: number;
    } | null | undefined;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"ChangeProjectRoleModal_person" | "ChangeWorkstreamModal_person" | "PlaceholderSidePanel_placeholder" | "PlaceholderWorkflowMenu_placeholder">;
  readonly " $fragmentType": "PlaceholderPlannerMenu_placeholder";
};
export type PlaceholderPlannerMenu_placeholder$key = {
  readonly " $data"?: PlaceholderPlannerMenu_placeholder$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaceholderPlannerMenu_placeholder">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "plannerStartDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaceholderPlannerMenu_placeholder",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "project_members",
      "kind": "LinkedField",
      "name": "project_memberships",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "workstreams",
          "kind": "LinkedField",
          "name": "workstream",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "first_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last_name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlaceholderWorkflowMenu_placeholder"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChangeWorkstreamModal_person"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "plannerStartDate",
          "variableName": "plannerStartDate"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PlaceholderSidePanel_placeholder"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChangeProjectRoleModal_person"
    }
  ],
  "type": "people",
  "abstractKey": null
};
})();

(node as any).hash = "e61add3250028ea3e625d1f055a0bd45";

export default node;
